import * as React from "react";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";

/**
 * Reusable Date/Time Picker
 * @param {"date"|"time"|"datetime"} type 
 * @param {Date|null} value 
 * @param {Function} onChange 
 * @param {string} label 
 */
export default function DateTimePicker({
  type = "date",
  value,
  onChange,
  label = "",
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      {type === "date" && (
        <DatePicker
          label={label}
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      )}

      {type === "time" && (
        <TimePicker
          label={label}
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      )}

      {type === "datetime" && (
        <DateTimePicker
          label={label}
          className="w-full"
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      )}
    </LocalizationProvider>
  );
}
